import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export function Footer() {
  return (
    <footer className="footer">
      <div className="wrap footer-row">
        <Link to="/" aria-label="$STRIKE home">
          <Logo size={22} />
        </Link>
        <nav className="footer-links">
          <Link to="/trade">Trade</Link>
          <Link to="/earn">Earn</Link>
          <Link to="/rewards">Rewards</Link>
          <Link to="/docs">Docs</Link>
        </nav>
      </div>
      <div className="wrap footer-legal">
        Options can expire worthless. Not investment advice. Not available in the United States.{" "}
        <span>
          Charts by{" "}
          <a href="https://www.tradingview.com/" target="_blank" rel="noreferrer">
            TradingView
          </a>
          .
        </span>
      </div>
    </footer>
  );
}
